import {
  createGyymApiClient,
  GyymApiClient,
  GyymClientOptions,
} from '@gyym/sdk'

export interface ClientComponentClientOptions extends GyymClientOptions {
  isSingleton?: boolean
}

let client: GyymApiClient

export const createClientComponentClient = ({
  baseURL = process.env.NEXT_PUBLIC_API_HOST,
  isSingleton = true,
  ...options
}: ClientComponentClientOptions = {}) => {
  const createClient = () =>
    createGyymApiClient({
      baseURL,
      ...options,
    })

  if (isSingleton) {
    const _client = client ?? createClient()

    // For SSG/SSR, always create a new client
    if (typeof window === 'undefined') return _client

    // Create the gyym client once in the client
    if (!client) client = _client

    return client
  }

  return createClient()
}
